import { getter } from './store';

export const getErrorMessage = getter('error', (state) => state.error)
